

<template>
  <div class="loginmgg">
    <div class="login-container"></div>
    <el-form
      :model="ruleForm2"
      :rules="rules2"
      status-icon
      ref="ruleForm2"
      label-position="left"
      label-width="0px"
      class="demo-ruleForm login-page"
    >
      <h3 class="title">欢迎登录</h3>
      <el-form-item prop="phone">
        <el-input
          type="number"
          v-model="ruleForm2.phone"
          auto-complete="off"
          placeholder="手机号"
        ></el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input
          type="password"
          v-model="ruleForm2.password"
          auto-complete="off"
          placeholder="密码"
        ></el-input>
      </el-form-item>
      <!-- <el-checkbox v-model="checked" class="rememberme">记住密码</el-checkbox> -->
      <el-form-item style="width: 100%">
        <el-button
          style="width: 100%; color: #fff"
          @click="handleSubmit"
          :loading="logining"
          class="logingre"
          >登录</el-button
        >
      </el-form-item>
      <p class="findpws">
        <span class="recolo" @click="hreftoregist">立即注册</span>
        <span class="wang" @click="findpassword">忘记密码</span>
      </p>
      <!-- <span>
        没有账号?
        
      </span> -->
    </el-form>
  </div>
</template>

<script>
import https from "../http.js";
import Cookies from "js-cookie";
import qs from "qs";
import $ from "jquery";
export default {
  data() {
    return {
      logining: false,
      ruleForm2: {
        phone: "",
        password: "",
      },
      rules2: {
        phone: [
          {
            required: true,
            message: "请输入手机号",
            trigger: "blur",
          },
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
      checked: false,
    };
  },
  methods: {
    handleSubmit(event) {
      // this.logining = true;
      var phoned = this.ruleForm2.phone;
      var passwordd = this.ruleForm2.password;
      if (phoned == "") {
        this.$message.error("请填写手机号");
        this.logining = false;
        return false;
      }

      if (passwordd == "") {
        this.$message.error("请填写密码");
        this.logining = false;
        return false;
      }

      var param = {
        phone: phoned,
        password: passwordd,
      };

      this.logining = true;

      https
        .fetchPost("/site/login", qs.stringify(param))
        .then((data) => {
          if (data.data.res_code == 1) {
            // localStorage.token = data.data.token
            // this.$cookies.set("token", data.data.token, "7d");
            // this.$cookies.set("username", data.data.user_info.username, "7d");
            // this.$cookies.set("avatarimg", data.data.user_info.avatarimg, "7d");
            // this.$cookies.set("userid", data.data.user_info.id, "7d");
            // this.$cookies.set("phone", data.data.user_info.phone, "7d");

            this.tool.setCookie("token", data.data.token, 7);
            this.tool.setCookie("username", data.data.user_info.username, 7);
            this.tool.setCookie("avatarimg", data.data.user_info.avatarimg, 7);
            this.tool.setCookie("userid", data.data.user_info.id, 7);
            this.tool.setCookie("phone", data.data.user_info.phone, 7);
            // sessionStorage.setItem("token", data.data.token);
            // sessionStorage.setItem("username", data.data.user_info.username);
            // sessionStorage.setItem("avatarimg", data.data.user_info.avatarimg);
            // sessionStorage.setItem("userid", data.data.user_info.id);
            // sessionStorage.setItem("phone", data.data.user_info.phone);
            // alert(data.data.token);

            this.$router.push({ path: "/Index" }); //测试
            window.location.reload();
          }

          if (data.data.res_code == 2) {
            this.$message.error("手机号或密码错误");
            this.logining = false;
          }

          console.log(data);

          //console.log();
        })
        .catch((err) => {
          console.log(err);
        });
    },

    hreftoregist() {
      this.$router.push({ path: "/regist" });
    },
    findpassword() {
      this.$router.push({
        path: "/Findpassword",
      });
    },
  },
};
</script>

<style scoped>
.findpws {
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
}
.findpws .wang {
  color: #cac6c6;
}
.loginmgg {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}

.logingre {
  /* background: linear-gradient(to right, #f4bd47, #ffa751); */
  background: linear-gradient(to right, #97c74e, #2ab9a5);
  border: 0px;
  color: #fff;
}

.logingre:hover {
  background: linear-gradient(to right, #97c74e, #2ab9a5);
  color: #fff;
}

.recolo {
  color: #2ab9a5;
  cursor: pointer;
}

.login-container {
  /* 加载背景图 */

  background-image: url(../assets/images/zhiyeindex.jpg);

  /* 当内容高度大于图片高度时，背景图像的位置相对于viewport固定 */

  background-attachment: fixed;

  /* 让背景图基于容器大小伸缩 */

  background-size: cover;
  position: fixed;
  width: 100%;
  height: 100%;
}
.login-page {
  -webkit-border-radius: 5px;
  border-radius: 5px;
  margin: 180px auto;
  width: 350px;
  padding: 35px 35px 15px;
  background: #fff;
  border: 1px solid #eaeaea;
  box-shadow: 0 0 25px #cac6c6;
  position: relative;
  overflow: auto;
}
label.el-checkbox.rememberme {
  margin: 0px 0px 15px;
  text-align: left;
}
</style>